/**
 * "Theming the widget" — Widget section (ADR-0074).
 * Reconciled from apps/widget theme (detect/extract, tokens, detected-schemes).
 */
import type { DocPageContent } from '../types';

export const WIDGET_THEMING_PAGE: DocPageContent = {
  slug: 'widget/theming',
  titleKey: 'docs.widget.theming.title',
  descriptionKey: 'docs.widget.theming.description',
  blocks: [
    { kind: 'paragraph', textKey: 'docs.widget.theming.lead' },

    { kind: 'heading', level: 2, id: 'auto', textKey: 'docs.widget.theming.auto.heading' },
    { kind: 'paragraph', textKey: 'docs.widget.theming.auto.body' },

    { kind: 'heading', level: 2, id: 'tokens', textKey: 'docs.widget.theming.tokens.heading' },
    { kind: 'paragraph', textKey: 'docs.widget.theming.tokens.body' },

    { kind: 'heading', level: 2, id: 'light-dark', textKey: 'docs.widget.theming.schemes.heading' },
    { kind: 'paragraph', textKey: 'docs.widget.theming.schemes.body' },

    { kind: 'heading', level: 2, id: 'studio', textKey: 'docs.widget.theming.studio.heading' },
    { kind: 'paragraph', textKey: 'docs.widget.theming.studio.body' },
    {
      kind: 'callout',
      tone: 'note',
      titleKey: 'docs.widget.theming.studio.note.title',
      textKey: 'docs.widget.theming.studio.note.body',
      links: {
        studio: {
          target: { docSlug: 'dashboard/design' },
          labelKey: 'docs.widget.theming.studio.note.link',
        },
      },
    },

    { kind: 'heading', level: 2, id: 'next', textKey: 'docs.common.nextSteps' },
    {
      kind: 'cardGrid',
      cards: [
        {
          titleKey: 'docs.widget.theming.next.surfaces.title',
          textKey: 'docs.widget.theming.next.surfaces.text',
          to: { docSlug: 'widget/configuration' },
        },
        {
          titleKey: 'docs.widget.theming.next.languages.title',
          textKey: 'docs.widget.theming.next.languages.text',
          to: { docSlug: 'languages' },
        },
      ],
    },
  ],
};
